module.exports = __webpack_public_path__ + "static/media/raven_funny_06.2e176fd3.svg";